import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { ManagerService } from './manager.service';
import { LocalService } from './local.service';

@Injectable({ providedIn: 'root' })
export class SellerPreferencesService {

  private challengePreference$!: Observable<boolean>;

  constructor(private managerService: ManagerService) {}

  getChallengePreference(): Observable<boolean> {
    if (!this.challengePreference$) {
      const userData = LocalService.get('userProfile');
      if (userData && userData.company && userData.company.id) {
        const companyParams = { companyId: userData.company.id };
        this.challengePreference$ = this.managerService.getCompanyPreferences(companyParams).pipe(
          map((data: any) => {
            const preference = data.companyPreferences.find(
              (item: any) => item.name === 'COMPANY_SALES_CHALLENGES_AND_REWARDS'
            );
            return preference ? preference.enabled : false;
          }),
          shareReplay(1)
        );
      } else {
        this.challengePreference$ = of(false);
      }
    }
    return this.challengePreference$;
  }
}
